import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { CONSTANTS, Loader, Logo, Toast, toast, ViewTerms, Icon, LoaderPageContainer } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { track, events } from 'src/configs/amplitude';
import React, { Suspense, useEffect, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { api } from 'src/api';
import { useStore } from 'src/stores';
import routes, { allocationsRoutes, ROUTES_TYPES } from 'src/configs/routes';
import { showFullPageView, isTenantPortal, noBottomPadding, hideContainerOverflow } from 'src/configs/pagesConfigs';
import getHeaderVariant from 'src/configs/headerConfigs';
import { PrivateRoute } from 'src/configs/privateRoute';
import { PublicRoute } from 'src/configs/publicRoute';
import { RestrictedRoute } from 'src/configs/restrictedRoute';
import { PmSidebar } from 'src/components/layout/PmSidebar';
import PagesSideDrawer from 'src/components/layout/PagesSideDrawer';
import { PayGateModal } from 'src/components/utilities/PayGateModal';
import { GlobalContext } from 'src/contexts/globalContext';
import MobilePage from 'src/pages/MobilePage';
import useStyles from './styles';
import { USER_SETTINGS_KEYS, HS_USER_KEYS, USER_ROLES_BY_NAME } from 'src/constants/userSetting';
import { IS_PAYMENT_METHOD } from 'src/constants/payments';
import { Button, LinearProgress, Link, Typography } from '@mui/material';
import { ToSModal } from 'src/components/shared/ToSModal';
import { REFRESH_TOKEN_KEY } from 'src/constants/notifications';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { parseJwt } from 'src/core/services/jwt';
import { Link as RouterLink } from 'react-router-dom';
import { autoBillingCredentialsIssueForceEnable as autoBillingCredentialsIssueForceEnableStorage } from 'src/configs/getAppPartsAccess';
import { UpdateUtilityCredentialsBatchModal } from 'src/components/shared/UpdateUtilityCredentialsBatchModal';
export const App = observer(() => {
  const classes = useStyles();
  const history = useLocation();
  const navigate = useNavigate();
  const store = useStore();
  const isDowntime = false;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    clientSecret = _useState2[0],
    setClientSecret = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAppLoded = _useState4[0],
    setIsAppLoded = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    noPaymentMethods = _useState6[0],
    setNoPaymentMethods = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    dashboardWizardStep = _useState8[0],
    setDashboardWizardStep = _useState8[1];
  const isDevelopment = process.env.ENVIRONMENT_NAME === 'develop' || process.env.ENVIRONMENT_NAME === 'staging';
  const openFlag = !(localStorage.getItem('sidebarIsOpen') === 'false' || localStorage.getItem('sidebarIsOpen') === null);
  const windowIsWide = window.innerWidth > CONSTANTS.MIN_WINDOW_WIDTH;
  const isOpen = () => windowIsWide ? openFlag : false;
  const _useState9 = useState(isOpen()),
    _useState0 = _slicedToArray(_useState9, 2),
    sidebarIsOpen = _useState0[0],
    setSidebarIsOpen = _useState0[1];
  const currentPath = history.pathname ? history.pathname : history.history.pathname;
  const showTerms = ['/fee-structure', '/payments', '/profile-settings'].includes(currentPath);
  const isFullPage = showFullPageView(currentPath);
  const toggleSidebar = () => {
    if (windowIsWide) {
      localStorage.setItem('sidebarIsOpen', !sidebarIsOpen);
    }
    setSidebarIsOpen(!sidebarIsOpen);
  };
  const header = getHeaderVariant(currentPath, toggleSidebar);
  store.auth.checkAuth();
  const getPaymentMethods = async () => {
    const resp = await store.payment.getPaymentMethodsAsync.run();
    return resp;
  };
  const getPublicKey = async () => {
    const resp = await store.payment.getPublicKeyAsync.run();
    return resp;
  };
  const getSetupIntentWithSubscription = async () => {
    const resp = await store.payment.getSetupIntentWithSubscriptionAsync.run();
    return resp;
  };
  useEffect(() => {
    setTimeout(() => {
      setIsAppLoded(true);
      try {
        const hsEmail = localStorage.getItem(HS_USER_KEYS.email);
        const hsToken = localStorage.getItem(HS_USER_KEYS.token);
        if (hsEmail && hsToken) {
          window.hsConversationsSettings = {
            identificationEmail: hsEmail,
            identificationToken: hsToken
          };
          window.HubSpotConversations.resetAndReloadWidget();
        }
      } catch (error) {}
    }, 2000);
  }, []);
  const checkPayment = async () => {
    const isCompany = localStorage.getItem(USER_SETTINGS_KEYS.company);
    const userRole = localStorage.getItem(USER_SETTINGS_KEYS.userRole);
    const paymentMethodValue = JSON.parse(localStorage.getItem(IS_PAYMENT_METHOD));
    const paygate = typeof paymentMethodValue === 'boolean' ? paymentMethodValue : false;
    const allowedRoutes = () => {
      return window.location.pathname !== '/' && window.location.pathname !== '/profile_saved' && window.location.pathname !== '/two_factor_auth' && window.location.pathname !== '/mfa' && window.location.pathname !== '/company_details' && window.location.pathname !== '/paygate';
    };
    const paygateCheck = () => {
      return !paygate && !store.account.userProfile.isDemoModeEnabled;
    };
    setNoPaymentMethods(false);
    if (allowedRoutes() && api.Account.isLoggedIn() && userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder && store.account.userProfile.isUserPropertyManagerAccountHolder && paygateCheck() && isCompany && isCompany !== null && isCompany !== 'null') {
      getPaymentMethods().then(() => {
        if (!store.payment.paymentMethods.length) {
          Promise.all([getPublicKey(), getSetupIntentWithSubscription().then(resp => {
            if (resp && resp.isSuccessful) {
              setClientSecret(resp.response.clientSecret);
            }
          })]).then(() => {
            setNoPaymentMethods(true);
            if (!store.account.isInvite) toast('warning', {
              body: ['You should add a payment method to use the service'] // ? i18n
            });
          });
        }
      });
    }
  };
  const checkPaymentWarning = async () => {
    if (window.location.pathname !== '/' && window.location.pathname !== '/profile_saved' && window.location.pathname !== '/two_factor_auth' && window.location.pathname !== '/mfa' && window.location.pathname !== '/company_details' && window.location.pathname !== '/paygate' && window.location.pathname !== '/admin' && window.location.pathname !== '/information_banners' && window.location.pathname !== '/appfolio' && api.Account.isLoggedIn()) await getPaymentMethods();
  };
  const checkNotifications = async () => {
    if (api.Account.isLoggedIn()) {
      await store.notifications.getPendingNotificationsAsync.run();
    }
  };
  const checkCompany = async () => {
    const isCompany = localStorage.getItem(USER_SETTINGS_KEYS.company);
    if (api.Account.isLoggedIn() && isCompany && isCompany !== null && isCompany !== 'null') {
      await store.company.getCurrentUserCompanyFromTokenAsync.run();
    }
  };
  useEffect(() => {
    checkPayment();
    track(events.pageNavigated(), {
      page_url: history.pathname
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);
  useEffect(() => {
    if (!store.admin.companyId && (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && history.pathname !== '/information_banners' && history.pathname !== '/appfolio' && history.pathname !== '/admin' &&
    // Cross-company by design: the queue lists every company's outstanding utilities and filters
    // by company as one option among several. Bouncing it to /admin for "no account selected"
    // made the route unreachable for the operators it exists for.
    history.pathname !== '/bill-queue' && history.pathname !== '/login') {
      navigate('admin');
      toast('warning', {
        body: ["You haven't selected any account yet.",
        // ? i18n
        'Please select account first!']
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);
  useEffect(() => {
    if (isDowntime) return;
    checkNotifications();
    checkPaymentWarning();
    checkCompany();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const routesList = routes.map(route => {
    if (route.path === '/billing_module' && route.label === 'New Billing Module') {
      route.path = '/active_dashboard';
    }
    if (route.path === '/active_dashboard' && route.label === 'Active Dashboard') {
      route.path = '/legacy_active_dashboard';
    }
    return route;
  }).filter(i => i !== undefined).map(route => {
    if (route.routeType === ROUTES_TYPES.PUBLIC) {
      return /*#__PURE__*/React.createElement(Route, {
        element: PublicRoute({
          component: route.component,
          path: route.path,
          exact: true
        }),
        exact: true,
        key: route.path,
        path: route.path
      });
    } else if (route.path === '/allocations') {
      return /*#__PURE__*/React.createElement(Route, {
        element: PrivateRoute({
          component: route.component,
          path: route.path,
          exact: true
        }),
        key: route.path,
        path: route.path
      }, /*#__PURE__*/React.createElement(Route, {
        element: PrivateRoute({
          component: allocationsRoutes[0].component,
          path: allocationsRoutes[0].path,
          exact: true
        }),
        key: route.path,
        path: "allocations_charges"
      }), /*#__PURE__*/React.createElement(Route, {
        element: PrivateRoute({
          component: allocationsRoutes[1].component,
          path: allocationsRoutes[1].path,
          exact: true
        }),
        key: route.path,
        path: "allocations_history"
      }));
    } else if (route.routeType === ROUTES_TYPES.PRIVATE) {
      return /*#__PURE__*/React.createElement(Route, {
        element: PrivateRoute({
          component: route.component,
          path: route.path,
          exact: true
        }),
        path: route.path,
        key: route.path
      }, route.path === '/active_dashboard' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
        path: ":navCompanyId"
      }, /*#__PURE__*/React.createElement(Route, {
        path: ":navPortfolioId"
      }, /*#__PURE__*/React.createElement(Route, {
        path: ":navPropertyId"
      }, /*#__PURE__*/React.createElement(Route, {
        path: "billing"
      }), /*#__PURE__*/React.createElement(Route, {
        path: "residents"
      }), /*#__PURE__*/React.createElement(Route, {
        path: "details"
      }), /*#__PURE__*/React.createElement(Route, {
        path: "appfolio-batches"
      }))))));
    } else if (route.routeType === ROUTES_TYPES.RESTRICTED) {
      return /*#__PURE__*/React.createElement(Route, {
        element: RestrictedRoute({
          restrictedType: route.restrictedType,
          component: route.component,
          key: route.path,
          path: route.path,
          exact: true
        }),
        path: route.path,
        key: route.path
      });
    }
  });
  const renderNavigation = () => {
    if (isFullPage || isTenantPortal(currentPath)) return;
    return /*#__PURE__*/React.createElement(PmSidebar, {
      history: history
    });
  };
  const getAppContainerClasses = () => {
    let appClasses = "".concat(classes.appContainer, " ");
    if (!isFullPage) {
      appClasses += "".concat(classes.topMargin, " ");
    }
    return appClasses;
  };
  const getPageContainerClasses = () => {
    let pageClasses = "".concat(classes.pageContainer, " ").concat(window.location.pathname === '/auto_billing_credentials' ? 'no-padding-on-resize' : '', " ");
    if (isFullPage) {
      pageClasses += "".concat(classes.fullPageContainer, " ");
    }
    if (isTenantPortal(currentPath)) {
      pageClasses += "".concat(classes.tenantPortalPageContainer, " ");
    }
    if (noBottomPadding(currentPath)) {
      pageClasses += "".concat(classes.noBottomPadding, " ");
    }
    if (hideContainerOverflow(currentPath)) {
      pageClasses += "".concat(classes.pageContainerOverflowHidden, " ");
    }
    return pageClasses;
  };
  const storageTokenEventHandler = async () => {
    if (localStorage.getItem(REFRESH_TOKEN_KEY) && JSON.parse(localStorage.getItem(REFRESH_TOKEN_KEY)) && api.Account.isLoggedIn()) {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      const accessTokenAsync = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken));
      if ((store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && history.pathname !== '/admin' && history.pathname !== '/appfolio' && (!accessTokenAsync['custom:companyid'] || accessTokenAsync['custom:companyid'] === null || accessTokenAsync['custom:companyid'] === 'null')) {
        store.admin.saveSelectedCompanyName(undefined);
        localStorage.removeItem(USER_SETTINGS_KEYS.company);
        localStorage.removeItem(USER_SETTINGS_KEYS.companyName);
        localStorage.removeItem('livable_portfolio_id');
        navigate('admin');
        return;
      }
      await store.notifications.getPendingNotificationsAsync.run({});
      await store.company.getCurrentUserCompanyFromTokenAsync.run();
      try {
        if (store.hubspot.getHubspotTokenAsync.inProgress) return;
        const hsResp = await store.hubspot.getHubspotTokenAsync.run();
        if (hsResp && hsResp.isSuccessful) {
          window.hsConversationsSettings = {
            identificationEmail: hsResp.response.email,
            identificationToken: hsResp.response.token
          };
          window.HubSpotConversations.resetAndReloadWidget();
        }
      } catch (error) {
        console.error('storageTokenEventHandler', error);
      }
    }
  };
  window.addEventListener('storage', storageTokenEventHandler);
  window.addEventListener('triggerStorageTokenEventHandler', storageTokenEventHandler);
  document.addEventListener('click', function (event) {
    const currentClick = event.target.getAttribute('custom-attribute');
    const lastClicks = JSON.parse(localStorage.getItem('livable_last_actions')) || [];
    if (!currentClick) return;
    if (lastClicks.length > 15) lastClicks.shift();
    if (lastClicks.length > 0) {
      if (lastClicks[lastClicks.length - 1] !== currentClick) {
        lastClicks.push(currentClick);
        localStorage.setItem('livable_last_actions', JSON.stringify(lastClicks));
      }
    } else {
      lastClicks.push(currentClick);
      localStorage.setItem('livable_last_actions', JSON.stringify(lastClicks));
    }
  });
  window.addEventListener('beforeunload', () => {
    localStorage.removeItem('livable_last_actions');
  }, false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isDowntime && /*#__PURE__*/React.createElement("div", {
    className: classes.errorPage
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.gradient
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.errorContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.downtime
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "settings"
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "settings"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h1"
  }, "\uD83D\uDEA7 Scheduled Maintenance in Progress"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light"
  }, "We're currently performing a scheduled maintenance to improve our system's performance and reliability.", /*#__PURE__*/React.createElement("br", null), "During this time, our services will be temporarily unavailable.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "We apologize for the inconvenience and appreciate your patience.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "If you have any urgent questions, please contact us at", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "mailto:tech@livable.com"
  }, "tech@livable.com")))), isMobileOnly && !isDowntime && process.env.ENVIRONMENT_NAME !== 'develop' && /*#__PURE__*/React.createElement(MobilePage, null), (!isMobileOnly || process.env.ENVIRONMENT_NAME === 'develop') && !isDowntime && /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: {
      dashboardWizardStep,
      setDashboardWizardStep,
      sidebarIsOpen,
      setSidebarIsOpen
    }
  }, !isFullPage && header, (store.payment.failedPaymentMethods || store.payment.warningPaymentMethods || autoBillingCredentialsIssueForceEnableStorage) &&
  // TODO: autoBillingCredentialsIssueForceEnableStorage replace with a flag that isCredentialFailed
  history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' && /*#__PURE__*/React.createElement("div", {
    className: classes.pendingWarningWrapper
  }, store.payment.warningPaymentMethods && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.pendingWarning)
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "warning",
    type: "warning"
  }), /*#__PURE__*/React.createElement("span", null, "Please verify your payment method ***", store.payment.warningPaymentMethods.last4, ".", store.payment.warningPaymentMethods.verificationDaysLeft ? " ".concat(store.payment.warningPaymentMethods.verificationDaysLeft, " days left.") : ''), /*#__PURE__*/React.createElement(Button, {
    target: "_blank",
    variant: "actionButton",
    component: RouterLink,
    to: store.payment.warningPaymentMethods.verificationUrl,
    'custom-attribute': '115-app'
  }, "Verify method")), store.payment.failedPaymentMethods && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.pendingWarning, " error")
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "warning",
    type: "warning"
  }), /*#__PURE__*/React.createElement("span", null, "Your payment method ***", store.payment.failedPaymentMethods.last4, " is failed."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => navigate('/payments?tab=payment_information'),
    'custom-attribute': '1-update-payment-method'
  }, "Update payment method")), autoBillingCredentialsIssueForceEnableStorage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.pendingWarning, " errorCredentials")
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "warning",
    type: "warning"
  }), /*#__PURE__*/React.createElement("span", null, "Auto-billing credentials issue. Please update them with valid information."), /*#__PURE__*/React.createElement(UpdateUtilityCredentialsBatchModal, {
    customTrigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      'custom-attribute': '2-update-credentials'
    }, "Update credentials")
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(getAppContainerClasses(), " ").concat(store.payment.failedPaymentMethods && store.payment.warningPaymentMethods && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? classes.topMarginWarningBoth : (store.payment.failedPaymentMethods || store.payment.warningPaymentMethods) && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? classes.topMarginWarning : '')
  }, !hideContainerOverflow(currentPath) && renderNavigation(), /*#__PURE__*/React.createElement("div", {
    className: getPageContainerClasses(),
    id: "pageContainer"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Loader, null)
  }, /*#__PURE__*/React.createElement(Routes, null, routesList, /*#__PURE__*/React.createElement(Route, {
    key: '*',
    path: "*",
    element: /*#__PURE__*/React.createElement(Navigate, {
      replace: true,
      to: "/error_page"
    })
  })), showTerms ? /*#__PURE__*/React.createElement(ViewTerms, null) : null)), isDevelopment ? /*#__PURE__*/React.createElement(PagesSideDrawer, null) : null, noPaymentMethods && clientSecret && !store.account.isInvite && /*#__PURE__*/React.createElement(PayGateModal, {
    noCancelletion: true,
    open: true
  }), /*#__PURE__*/React.createElement(Toast, null)), (!isAppLoded || store.admin.isAdminSwitchToNewAccount || store.account.isEnablingDemoModeState) && /*#__PURE__*/React.createElement("div", {
    className: classes.globalLoader
  }, /*#__PURE__*/React.createElement(Logo, null)), (store.account.isSavingCompany || store.account.isSavingPaygate) && /*#__PURE__*/React.createElement("div", {
    className: classes.registrationLoader
  }, /*#__PURE__*/React.createElement(LoaderPageContainer, null, /*#__PURE__*/React.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1"
  }, store.account.isSavingCompany ? 'Saving your business details' : 'Saving your payment information'), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.additionalInfo
  }, store.account.isSavingCompany ? 'Please wait a few seconds while we save your business details.' : 'Please wait a few seconds while we save your payment details.'), /*#__PURE__*/React.createElement(LinearProgress, null)))), !!store.notifications.currentTos && /*#__PURE__*/React.createElement(ToSModal, {
    noCancelletion: true,
    open: true
  })));
});